import React from "react";
import { logout } from "../../apiCalls/auth";
import { Grid, Typography, Button } from "@mui/material";

export default function AlertPage({ alertEmail, alertMsg }) {
  return (
    <Grid
      container
      sx={{
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <Grid
        item
        sx={{
          width: "500px",
          height: "200px",
          backgroundColor: "#FFFFFF",
          borderRadius: "20px",
        }}>
        <Grid container sx={{ width: "100%", height: "100%", padding: "10px" }}>
          <Grid
            item
            sx={{
              width: "100%",
              height: "50%",
              padding: "10px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}>
            <Typography
              sx={{
                textAlign: "center",
                font: "normal normal bold 16px/20px Quicksand",
                letterSpacing: "0px",
                color: "#6F8090",
              }}>
              {alertMsg ||
                `${alertEmail} does not exist, please reenter credentials or contact Innovare for support.`}
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              width: "100%",
              height: "50%",
              padding: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <Button
              onClick={() => logout()}
              sx={{
                backgroundColor: "#AC5CCC",
                color: "#FFFFFF",
                "&:hover": { backgroundColor: "#AC5CCB", color: "#FFFFFF" },
              }}>
              OK
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
